import React from 'react';
import { useRef } from 'react';
import { InView } from "react-intersection-observer";
import '../App.css'
//
import DivLine from '../svg/special/DivLine.js'
import DivLine2 from '../svg/special/DivLine2.js'
import BackTop from '../svg/home/BackTop.js'
//
import Nav from '../components/Nav.js';
import Footer from '../components/Footer.js';
import About from '../components/About.js';

import InViewComponent from '../components/InViewComponent.js';
const AboutUs = ({scrollRef, handleSetRightNav}) => {
    const leftRigthBGRef1 = useRef(null);
    const bottomAppearRef1 = useRef(null);
    const decoLine1Ref = useRef(null);
    const decoLine2Ref = useRef(null);
    const titleRef = useRef(null);
    const titleRef1 = useRef(null);
    return (
        <div className='w-full flex-col items-center'>
            {/* <div className='w-full h-[93vh] sticky top-0' style={{zIndex:1}}>
                <img src='../img/aboutus/newbg_bg.png' className='h-[93vh] w-full' style={{objectFit:'cover', aspectRatio:3840/1774}}></img>
                <div className='w-full h-full flex flex-row-col items-center justify-center absolute top-0 left-0' style={{gap:24}}>
                    <img src='../img/aboutus/newbg_phone.png' className='max-w-[25vw] min-w-[200px] d-flex1-m-none' style={{aspectRatio:427/533, height:undefined}}></img>
                    <div className='flex flex-col items-start' style={{}}>
                        <img src='../img/aboutus/newbg_text.png' className='max-w-[15vw] min-w-[200px] mb-[10%]' style={{aspectRatio:300/250, height:undefined, flex:1}}></img>
                        <div className='flex flex-row items-center justify-center gap-[8px]'>
                            <AppleBtn />
                            <PlayBtn />
                        </div>
                    </div>
                </div>
            </div> */}
            <Nav scrollRef={scrollRef} handleSetRightNav={handleSetRightNav} onlyIcon={true}/>
            <div className='grey-bg w-full flex flex-col items-center relative' style={{backgroundImage: `url(../img/home/bg_grain.png)`,zIndex:2,backgroundSize:'cover' }}>
                <div className='w-full flex flex-col items-center relative h-full min-h-[850px] mt-[80px]' style={{zIndex:2}}>
                    <div className='w-[4px] h-[4px] bg-[#AEA373] rounded-full'></div>
                    <div ref={titleRef} className='mt-[22px] mb-[36px] text-[35px] text-[#614E33] font-bold appear_bottom_to_top'>帶您穿梭香港</div>
                    <InViewComponent reffing={titleRef} active={'appear_bottom_to_top_active'}/>

                    <InView as="div" className='w-full flex flex-row items-start justify-start' onChange={(inView, entry) => {if(inView)decoLine1Ref.current.classList.add('deco_line_ani_is-active')}}>
                        <div ref={decoLine1Ref} className='w-full flex flex-row items-start justify-start deco_line_ani' style={{zIndex:1}}>
                            <DivLine className=''/>
                        </div>
                    </InView>
                    <InView className='w-full mt-[64px]' as="div" onChange={(inView, entry) => {if(inView)leftRigthBGRef1.current.classList.add('div_left_right_container_is-active')}}>
                        <div ref={leftRigthBGRef1} className='div_left_right_container flex flex-col items-center justify-center'>
                            <span className='text-black text-14 text-center' style={{display:'block'}}>以尊貴身份盡享跨領域的禮遇，</span>
                            <span className='text-black text-14 text-center mt-[18px]' style={{display:'block'}}>開闢前所未見的購物藝術之旅。</span>
                            <span className='text-black text-14 text-center mt-[18px]' style={{display:'block'}}>從非凡服務、獨家藝術及文化活動、生日驚喜、尊貴禮遇，</span>
                            <span className='text-black text-14 text-center mt-[18px]' style={{display:'block'}}>以至更多獨特的生活品味獎賞，一一觸手可及。</span>
                        </div>
                    </InView>
                    <div ref={bottomAppearRef1} className='cursor-pointer appear_bottom_to_top my-[80px] w-[80%] h-[70px] max-w-[850px] relative flex flex-row items-center justify-center text-[#000000] text-14 font-[500]'>
                        <div className='w-[100%] h-full border rounded-full border-[#DDCFA2] border-[2px] absolute left-0'></div>
                        <div className='w-[90%] h-full border rounded-full border-[#DDCFA2] border-[2px] flex flex-row items-center justify-center text-center text-[#614E33] font-bold d-fsize-25-m-20 white-btn-grad'>
                            立即登記成為T.Gather特級會員，盡享精彩禮遇！
                        </div>
                    </div>
                    <InView className='w-full' as="div" onChange={(inView, entry) => {if(inView)bottomAppearRef1.current.classList.add('appear_bottom_to_top_active')}}>
                    </InView>
                    <InView as="div" className='w-full flex flex-row items-end justify-end' onChange={(inView, entry) => {if(inView)decoLine2Ref.current.classList.add('deco_line_ani_is-active')}}>
                        <div ref={decoLine2Ref} className='w-full flex flex-row items-end justify-end deco_line_ani' style={{zIndex:1}}>
                            <DivLine2 className=''/>
                        </div>
                    </InView>
                </div>
                {/* Section  3 */}
                <div className='grey-bg w-full flex flex-col items-center justify-center relative' style={{zIndex:2}}>
                    {/* <InView as="div" className='absolute top-[1000px]' onChange={(inView, entry) => {if(inView)sticky1Ref.current.classList.add('sticky-inactive')}}>
                    </InView> */}
                    <div className='w-full flex flex-row items-center justify-center relative' style={{zIndex:3}}>
                        {/* <img src='./img/home/special_title.png' className='w-[30%] min-w-[350px] max-w-[400px] absolute bottom-[-50%]' style={{aspectRatio:1434/170, height:undefined}}></img> */}
                        <div ref={titleRef1} className='appear_bottom_to_top subtitle-gra p-[6px] absolute top-[-100%]'>
                            <div className='border subtitle-text d-padx-150-m-50 py-[6px] text-nowrap'>T.Gather平台特色</div>
                        </div>  
                        <div className='w-full h-[50px] bg-[#D9D9D9]'></div>
                    </div>
                    <InViewComponent reffing={titleRef1} active={'appear_bottom_to_top_active'}/>
                    <div className='w-full bg-gold flex flex-row-col items-end justify-center py-[6vh] relative'>
                        <About speicalIdx={0} isSpecial={true}/>
                        <div className='w-[7vw] h-full absolute top-0 right-0 speical-sidebar' style={{zIndex:0}}></div>
                    </div>
                    <div className='w-full bg-[#E3DDD5] flex flex-row-col items-end justify-center py-[6vh] relative'>
                        <About speicalIdx={1} isSpecial={true} isFlipped={true}/>
                        <div className='w-[7vw] h-full absolute top-0 left-0 sidebar-gra-white' style={{zIndex:0}}></div>
                    </div>
                    <div className='w-full bg-gold flex flex-row-col items-end justify-center py-[6vh] relative'>
                        <About speicalIdx={2} isSpecial={true}/>
                        <div className='w-[7vw] h-full absolute top-0 right-0 speical-sidebar' style={{zIndex:0}}></div>
                    </div>
                    <div className='w-full bg-[#E3DDD5] flex flex-row-col items-end justify-center py-[6vh] relative'>
                        <About speicalIdx={3} isSpecial={true} isFlipped={true}/>
                        <div className='w-[7vw] h-full absolute top-0 left-0 sidebar-gra-white' style={{zIndex:0}}></div>
                    </div>
                </div>
                <div className='mt-[5%] w-full h-full flex flex-row items-end justify-end px-[8vw] pb-[50px]'>
                    <div className='select-none cursor-pointer' onClick={() => {scrollRef.current.style.scrollBehavior = 'smooth';scrollRef.current.scrollTop = 0; setTimeout(() => {scrollRef.current.style.scrollBehavior = 'auto'}, 1000)}}>
                        <BackTop className=''/>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default AboutUs;